'use client'
import { hubHandler, useGetHubSelected } from '@core/auth'
import { IHub } from '@core/auth/hooks/use-get-hubs-list/use-get-hubs-list.hook.types'
import { useComponentTranslation } from '@core/i18n'
import {
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@core/ui-elements'
import { isMobile } from '@utils/utilities'
import { useMemo } from 'react'
import { IoIosArrowForward } from 'react-icons/io'

const HubSwitcher = ({
  handleCollapse,
}: {
  handleCollapse?: (command?: boolean) => void
}) => {
  const t = useComponentTranslation('MainLayout')
  const { getHubsList, setHubSelected } = hubHandler()
  const { hubId, hubSelected } = useGetHubSelected()
  const hubList = useMemo(() => getHubsList() ?? [], [getHubsList])

  const isOnlyOneHub = hubList.length < 2

  const handleHubSelect = (hub: IHub) => {
    setHubSelected(hub.id)
    if (handleCollapse) handleCollapse(true)
  }

  if (!hubList.length) return null

  return (
    <Menu variant={'hubMenu'}>
      <MenuButton
        _hover={isOnlyOneHub ? {} : undefined}
        cursor={isOnlyOneHub ? 'default' : undefined}
      >
        <Flex
          alignItems={'center'}
          flexDirection={'row'}
          justifyContent={isOnlyOneHub ? 'center' : 'space-between'}
          width={'100%'}
        >
          <Text
            as={'span'}
            data-testid="hubSelected"
            marginLeft={'0.75rem'}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            whiteSpace={'nowrap'}
          >
            {hubSelected?.alias}
          </Text>
          {isOnlyOneHub ? null : (
            <Button as={'span'} variant={'ghost'}>
              {t('Change')}
            </Button>
          )}
        </Flex>
      </MenuButton>
      {isOnlyOneHub ? null : (
        <MenuList>
          {hubList.map((hub) => {
            if (!hub.isActive) return null
            return (
              <MenuItem
                key={hub.id}
                aria-selected={hubId === hub.id}
                onClick={() => handleHubSelect(hub)}
              >
                <Text
                  as={'span'}
                  flex={1}
                  overflow={'hidden'}
                  textOverflow={'ellipsis'}
                  whiteSpace={'nowrap'}
                >
                  {hub.alias}
                </Text>
                <Button
                  as={'span'}
                  flex={'0 0 auto'}
                  isDisabled={hubId === hub.id}
                  paddingX={'0.5rem'}
                  variant={'ghost'}
                >
                  {hubId === hub.id ? (
                    t('Current Store')
                  ) : isMobile() ? (
                    <Icon as={IoIosArrowForward} />
                  ) : (
                    t('Access')
                  )}
                </Button>
              </MenuItem>
            )
          })}
        </MenuList>
      )}
    </Menu>
  )
}

export default HubSwitcher
